import { Link } from "react-router-dom";
import { Leaf, Mail, Phone, MapPin, Instagram, Facebook } from "lucide-react";
import { brand } from "../mock";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-neutral-200 bg-neutral-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div>
          <div className="flex items-center gap-2">
            <span className="w-9 h-9 rounded-full bg-green-600 text-white flex items-center justify-center">
              <Leaf size={18} />
            </span>
            <span className="font-extrabold text-lg">{brand.name}</span>
          </div>
          <p className="mt-4 text-sm text-neutral-600 leading-relaxed">
            Fresh, high-protein Indian &amp; fusion tiffin meals delivered across Auckland. Cooked daily, portion-controlled, and always without preservatives.
          </p>
          <div className="flex items-center gap-3 mt-5">
            <a href="#" aria-label="Instagram" className="w-9 h-9 rounded-full border border-neutral-300 hover:border-green-600 hover:text-green-700 flex items-center justify-center transition-colors">
              <Instagram size={16} />
            </a>
            <a href="#" aria-label="Facebook" className="w-9 h-9 rounded-full border border-neutral-300 hover:border-green-600 hover:text-green-700 flex items-center justify-center transition-colors">
              <Facebook size={16} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-sm font-bold uppercase tracking-wider text-neutral-900">Explore</h4>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/plans" className="text-neutral-600 hover:text-green-700">Meal Plans</Link></li>
            <li><Link to="/menu" className="text-neutral-600 hover:text-green-700">Menu</Link></li>
            <li><Link to="/about" className="text-neutral-600 hover:text-green-700">About Us</Link></li>
            <li><Link to="/contact" className="text-neutral-600 hover:text-green-700">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-bold uppercase tracking-wider text-neutral-900">Contact</h4>
          <ul className="mt-4 space-y-3 text-sm text-neutral-600">
            <li className="flex items-start gap-2"><Mail size={14} className="mt-1 text-green-700" /> {brand.email}</li>
            <li className="flex items-start gap-2"><Phone size={14} className="mt-1 text-green-700" /> {brand.phone}</li>
            <li className="flex items-start gap-2"><MapPin size={14} className="mt-1 text-green-700" /> {brand.city}, New Zealand</li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-bold uppercase tracking-wider text-neutral-900">Delivery Days</h4>
          <p className="mt-4 text-sm text-neutral-600">{brand.deliveryDays}</p>
          <p className="mt-3 text-xs text-neutral-500">Cutoff: 10pm the day before delivery.</p>
        </div>
      </div>

      <div className="border-t border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-neutral-500">
          <p>© {new Date().getFullYear()} {brand.name}. All rights reserved.</p>
          <p>Made fresh in Auckland, Aotearoa.</p>
        </div>
      </div>
    </footer>
  );
}
